import { create, tsx } from '@dojo/framework/core/vdom';

import * as css from './HomeHeroBackground.m.css';

const wave1 = require('../assets/images/header-section-backgrounds/home/wave-1.svg');
const wave2 = require('../assets/images/header-section-backgrounds/home/wave-2.svg');
const wave3 = require('../assets/images/header-section-backgrounds/home/wave-3.svg');
const wave4 = require('../assets/images/header-section-backgrounds/home/wave-4.svg');

const factory = create();

export const HomeHeroBackground = factory(function HomeHeroBackground() {
	return (
		<div>
			<img classes={[css.wave]} src={wave4} alt="" />
			<img classes={[css.wave]} src={wave3} alt="" />
			<img classes={[css.wave, css.wave2]} src={wave2} alt="" />
			<img classes={[css.wave, css.wave1]} src={wave1} alt="" />
		</div>
	);
});

export default HomeHeroBackground;
